
import { supabase } from "@/integrations/supabase/client";
import { useQuery } from "@tanstack/react-query";

// Define a more comprehensive venue type 
interface VenueDetails {
  venue_id?: string;
  name: string;
  address: string;
  image_url?: string | null;
  style?: string | null;
  price_range?: string | null;
  website_url?: string | null;
  instagram_handle?: string | null;
  google_maps_link?: string | null;
}

export const useVenueDetails = (eventId: string) => {
  return useQuery({
    queryKey: ['venue', eventId],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('event_venue_recommendations')
        .select(`
          recommendation_id,
          is_selected,
          venue:venues (
            venue_id,
            name,
            address,
            image_url,
            style,
            price_range,
            website_url,
            instagram_handle,
            google_maps_link
          )
        `)
        .eq('event_id', eventId)
        .eq('is_selected', true)
        .maybeSingle();

      if (error) {
        console.error('Error fetching venue:', error);
        throw error;
      }

      // If we have venue data, return it with the correct type structure
      if (data?.venue) {
        const venue = data.venue as VenueDetails;
        return venue;
      }
      
      return null;
    },
  });
};
